import React, { memo } from 'react';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';
import AutoComplete from '../helpers/AutoComplete';
import ErrorList from '../helpers/ErrorList';
import FormGroup from '../helpers/FormGroup';

const mimeTypes =
  '.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const UploadTemplatePopup = props => {
  const {
    fileName,
    isValid,
    inputErrors,
    isUploading,
    suggestions,
    getNextSuggestion,
    getSuggestion,
    getSuggestionValue,
    renderSuggestion,
    onClose,
    onSelectFile,
    onUpload,
  } = props;

  const suggestionProps = {
    inputProps: {
      id: 'module',
      name: 'module',
      label: 'Module',
      placeholder: '',
    },
    name: 'module',
    formGroupClass: 'col-sm-6',
    suggestions,
    loading: props.moduleLoading,
    text: props.moduleText,
    onUpdateSuggestions: props.updateSuggestions,
    getSuggestion,
    getNextSuggestion,
    getSuggestionValue,
    renderSuggestion,
    onSuggestionSelected: props.suggestionSelected,
    suggestIfEmpty: true,
  };

  const header = 'Template Upload';
  const footer = (
    <>
      <Button
        key="upload"
        className="btn-primary"
        disabled={!isValid || isUploading}
        form="uploadTemplateForm"
        type="submit"
      >
        Upload
      </Button>
      <Button key="cancel" onClick={onClose}>
        Cancel
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="uploadTemplate">
      <form id="uploadTemplateForm" onSubmit={onUpload}>
        <div className="row">
          <AutoComplete {...suggestionProps} />
          <FormGroup className="col-sm-6">
            <label className="field-label" htmlFor="upload-template-name">
              Template File
            </label>
            <div className="input-group">
              <input
                className="form-control"
                id="upload-template-name"
                placeholder="No file selected"
                value={fileName || ''}
                readOnly
              />
              <span className="input-group-btn">
                <label
                  className="btn btn-default"
                  htmlFor="upload-template-file"
                  // The label is styled as a button that opens the hidden file input.
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex="0"
                >
                  <input
                    accept={mimeTypes}
                    className="input-file-button"
                    id="upload-template-file"
                    name="file"
                    onChange={onSelectFile}
                    type="file"
                  />
                  Browse
                </label>
              </span>
            </div>
          </FormGroup>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <ErrorList errors={inputErrors} />
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default memo(UploadTemplatePopup);
